/**
 * Root Reducer
 * combine all reducers to create root reducer
 */
import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { authReducer } from './slices/authSlice';
import { commonReducer } from './slices/commonSlice';
import { modulesReducer } from '../pages/Modules/modulesSlice';
import { programsReducer } from '../pages/Programs/programsSlice';
import { resourcesReducer } from '../pages/Resources/resourcesSlice';
import { microPracticesReducer } from '../pages/MicroPractices/microPracticesSlice';
import { playlistsReducer } from '../pages/Playlists/playlistsSlice';
import { usersReducer } from '../pages/Users/usersSlice';
import { settingsReducer } from './slices/settingsSlice';
import { programCategoriesReducer } from '../pages/Categories/programCategoriesSlice';
import { resourceCategoriesReducer } from '../pages/Categories/resourceCategoriesSlice';
import { subscriptionReducer } from './slices/subscriptionSlice';
import { playlistAnalyticsReducer } from './slices/playlistAnalyticsSlice';
import { checkInAnalyticsReducer } from './slices/checkInAnalyticsSlice';
import { journalAnalyticsReducer } from './slices/journalAnalyticsSlice';
import { overviewCountsReducer } from './slices/overviewCountsSlice';
import { rolesReducer } from '../pages/Roles/rolesSlice';
import { permissionsReducer } from '../pages/Permissions/permissionsSlice';

/*-----[ persist configurations ]------*/
const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'common'],
  blacklist: ['common'], // We'll handle common separately
};

const commonPersistConfig = {
  key: 'common',
  storage,
  blacklist: ['loader'],
};

const appReducer = combineReducers({
  common: persistReducer(commonPersistConfig, commonReducer),
  auth: authReducer,
  modules: modulesReducer,
  programs: programsReducer,
  resources: resourcesReducer,
  microPractices: microPracticesReducer,
  playlists: playlistsReducer,
  users: usersReducer,
  settings: settingsReducer,
  programCategories: programCategoriesReducer,
  resourceCategories: resourceCategoriesReducer,
  subscription: subscriptionReducer,
  playlistAnalytics: playlistAnalyticsReducer,
  checkInAnalytics: checkInAnalyticsReducer,
  journalAnalytics: journalAnalyticsReducer,
  overviewCounts: overviewCountsReducer,
  roles: rolesReducer,
  permissions: permissionsReducer,
});

const persistRootReducer = persistReducer(rootPersistConfig, appReducer);

export type RootState = ReturnType<typeof appReducer>;

export { persistRootReducer };

